import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { BlockComponent } from "@components/container-block/block.component";
import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-stolp",
    templateUrl: "./stolp.component.html",
    styleUrls: ["./stolp.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        FormsModule,
        ReactiveFormsModule,
        HotDocComponent,
        InputNumberComponent
    ]
})
export class StolpComponent implements OnChanges, OnInit {
    form: UntypedFormGroup;
    hotDoc: HotDoc;
    @Input() rootForm: UntypedFormGroup;
    @Input() validationContext: IValidationContext;
    @Input() viewModel: ProduktdefinitionViewModel;

    private readonly formBinder = inject(FormBinderService);
    private readonly formId = "produktinstruktioner-details-stolp";
    private readonly raskModalService = inject(RaskModalService);

    initMatrisSettings = () => {
        this.hotDoc = this.viewModel.stolpdata.matrisdata.stolpmatris.getStolp(this.raskModalService, this.rootForm);
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.viewModel && changes.viewModel.currentValue.stolpdata !== changes.viewModel.previousValue?.stolpdata) {
            this.initMatrisSettings();
            if (this.form) {
                this.formBinder.reBindForm(this.form, this.viewModel.stolpdata);
            }
        }
    }

    ngOnInit(): void {
        this.initializeForm();
    }

    private initializeForm() {
        this.form = this.formBinder.CreateGroup(this.viewModel.stolpdata);
        this.rootForm.addControl(this.formId, this.form);
        if (!this.viewModel.canEdit) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }
}
